module.exports = __webpack_public_path__ + "static/work65-cc6320067efaac496b00144aee10ad6f.jpg";